export const MFA_ENABLE_VERIFICATION_FORM = 'MFA_ENABLE_VERIFICATION_FORM';
export const MFA_DISABLE_VERIFICATION_FORM = 'MFA_DISABLE_VERIFICATION_FORM';

export const ENABLE_MFA_MODAL = 'ENABLE_MFA_MODAL';
export const DISABLE_MFA_MODAL = 'DISABLE_MFA_MODAL';
